<template>
  <div>
    <associar-formulario-dialog
      :is-add-new-formulario-sidebar-active.sync="isAddNewFormularioSidebarActive"
      :ordens-permitidas="ordensPermitidas"
      @refetch-data="getTipoSolicitacaoFormularios"
    />

    <v-card
      flat
      class="pa-3 mt-2"
    >
      <v-card class="d-flex justify-space-between">
        <v-card-title>Formulários</v-card-title>
        <v-btn
          v-if="!acessoPost"
          color="primary"
          class=" ma-3"
          disabled
        >
          <span>Adicionar</span>
        </v-btn>

        <v-btn
          v-else
          color="primary"
          class=" ma-3"
          @click="isAddNewFormularioSidebarActive = !isAddNewFormularioSidebarActive"
        >
          <span>Adicionar</span>
        </v-btn>
      </v-card>

      <div style="min-height: 4px">
        <v-progress-linear
          v-if="loading"
          indeterminate
          @refetch-data="getTipoSolicitacaoFormularios"
        />
      </div>

      <table-associacao-tipo-solicitacao-formulario
        :items="tipoSolicitacaoFormulario"
        :acesso-disable="acessoDisable"
        @refetch-data="getTipoSolicitacaoFormularios"
      />
    </v-card>
  </div>
</template>

<script>
import { ref, onMounted, computed } from '@vue/composition-api'
import { mapState } from 'pinia'
import router from '@/router'
import useAuthStore from '@/store/auth'
import AssociarFormularioDialog from './AssociarFormularioDialog.vue'
import TableAssociacaoTipoSolicitacaoFormulario from './TableAssociacaoTipoSolicitacaoFormulario.vue'
import TipoSolicitacaoService from '@/services/modules/TipoSolicitacaoService'

export default {
  components: {
    TableAssociacaoTipoSolicitacaoFormulario,
    AssociarFormularioDialog,
  },

  props: {
    ativo: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      idPost: 2072,
      acessoPost: true,
      idDisable: 2073,
      acessoDisable: true,
    }
  },

  computed: {
    ...mapState(useAuthStore, ['funcionalidades']),
  },

  mounted() {
    // this.permissoes()
  },

  methods: {
    permissoes() {
      if (!this.funcionalidades.includes(this.idPost)) {
        this.acessoPost = false
      }
      if (!this.funcionalidades.includes(this.idDisable)) {
        this.acessoDisable = false
      }
    },
  },

  setup() {
    const isAddNewFormularioSidebarActive = ref(false)

    const tipoSolicitacaoFormulario = ref([])
    const loading = ref(false)

    async function getTipoSolicitacaoFormularios() {
      try {
        loading.value = true
        tipoSolicitacaoFormulario.value = await TipoSolicitacaoService.getTipoSolicitacaoFormulario(router.currentRoute.params.id)
      } finally {
        loading.value = false
      }
    }
    onMounted(getTipoSolicitacaoFormularios)

    const ordensPermitidas = computed(() => Array.from({ length: tipoSolicitacaoFormulario.value.filter(it => !!it.formularioId).length + 1 }, (_, index) => index + 1))

    return {
      isAddNewFormularioSidebarActive,
      tipoSolicitacaoFormulario,
      loading,
      getTipoSolicitacaoFormularios,
      ordensPermitidas,
    }
  },
}
</script>
